import { useRef, useState } from 'react';
import { PageHero } from '@/components/PageHero';
import { PageLayout } from '@/components/PageLayout';
import { Seo } from '@/components/Seo';
import { SiteLink } from '@/components/SiteLink';
import { ROUTES } from '@/constants/site';
import { PlanTable } from './PlanTable';
import { UnitModal } from './UnitModal';
import { UnitPopover } from './UnitPopover';

const DESCRIPTION =
  'Nova 온프레미스 구축형 플랜(Professional·Enterprise·Enterprise Plus)의 조사량, 사용자, 연동, 지원 수준별 기능 비교와 요금 안내.';

export default function PlanPage() {
  const [unitModalOpen, setUnitModalOpen] = useState(false);
  const popoverTriggerRef = useRef(null);

  return (
    <>
      <Seo
        title="플랫폼 플랜 상세"
        ogTitle="플랫폼 플랜 상세 — 온프레미스 구축형 요금 | Nova"
        description={DESCRIPTION}
        path={ROUTES.plan}
      />
      <PageLayout bodyClass="page-plan">
        <PageHero title="플랫폼 플랜 상세">
          플레인비트의 플랫폼은 다양한 분야의
          <br />
          분석 요구사항을 충족할 수 있는 솔루션을 제공합니다.
        </PageHero>

        <section aria-labelledby="pricing-title" className="bg-white py-20">
          <div className="inner">
            <header className="mb-16">
              <h2 id="pricing-title" className="plan-title headline-stack">
                <span className="heading-line">온프레미스 구축형 요금</span>
              </h2>
              <p className="plan-subtitle mt-5">실용적인 서비스 구성과 기능별 플랜 제공</p>
              <p className="plan-note mt-4">
                ※ PLAINBIT Nova 온프레미스 구축형은 연간 구독 방식으로 제공되며,
                조사량·사용자·연동·지원 수준에 따라 3개 플랜으로 구성됩니다.
              </p>
              <UnitPopover
                triggerRef={popoverTriggerRef}
                onOpenDetail={() => setUnitModalOpen(true)}
              />
            </header>

            <PlanTable />

            <p className="mt-16 text-center">
              <SiteLink to={ROUTES.inquiry} className="btn-cta w-[260px]">
                제품 도입 문의하기
              </SiteLink>
            </p>
          </div>
        </section>

        <UnitModal
          open={unitModalOpen}
          onClose={() => setUnitModalOpen(false)}
          returnFocusRef={popoverTriggerRef}
        />
      </PageLayout>
    </>
  );
}
